import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const UK_TIMEZONE = "Europe/London";

const DATE_FORMAT = "DD/MM/YYYY";
const TIME_FORMAT = "h:mm A";
const DATE_TIME_FORMAT = "DD/MM/YYYY [at] h:mm A";

const HAS_OFFSET = /(Z|[+-]\d{2}:?\d{2})$/i;

/**
 * Timestamps without an explicit offset are UTC on the backend, so they must be
 * read as UTC rather than in the browser's local zone before converting to UK.
 */
export function toUkTime(value?: string | null): Dayjs | null {
  if (!value) return null;
  const parsed = HAS_OFFSET.test(value.trim())
    ? dayjs(value)
    : dayjs.utc(value);
  if (!parsed.isValid()) return null;
  return parsed.tz(UK_TIMEZONE);
}

export function formatUkDate(value?: string | null, fallback = "—"): string {
  return toUkTime(value)?.format(DATE_FORMAT) ?? fallback;
}

export function formatUkTimeOfDay(
  value?: string | null,
  fallback = "—",
): string {
  return toUkTime(value)?.format(TIME_FORMAT) ?? fallback;
}

export function formatUkDateTime(value?: string | null, fallback = "—"): string {
  return toUkTime(value)?.format(DATE_TIME_FORMAT) ?? fallback;
}
